<template>
  <card
    title="איחורים בהחזרה"
    :linkTo="`/orders?orderStatuses=${bookedOutStatusId}&endDateBefore=${format(Date(), 'YYYY-MM-DD')}`"
    actionButton="לכל האיחורים בהחזרה"
    :number="number"
    :loading="loading"
    :error="error"
  />
</template>

<script>
import { format, addDays } from 'date-fns';
import { getApi } from '@/api';
import Card from "./Card.vue";

export default {
  data() {
    return {
      number: 0,
      loading: false,
      error: false
    };
  },

  computed: {
    bookedOutStatusId() {
      let paidStatus = Object.values(this.$store.state.entities.orderStatuses).find(item => {
        return item.key === 'BOOKED_OUT';
      })
      return paidStatus ? paidStatus._id : null;
    }
  },

  methods: {
    format,
    addDays,
    fetchData() {
      this.loading = true;
      getApi()
        .then(api => {
          let params = {
            endDateBefore: format(Date(), 'YYYY-MM-DD'),
            orderStatuses: this.bookedOutStatusId
          };
          return api.get('/orders', { params })
        })
        .then(({ data }) => {
          this.number = data.totalResults;
        })
        .catch(err => {
          console.log(err);
          this.error = true;
        })
        .finally(() => {
          this.loading = false;
        })
    }
  },

  props: [],

  mounted() {
    this.fetchData();
  },

  components: {
    Card
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
</style>
